import { Button, Form, Input, Select } from "antd";
import React from "react";
import { REPORT_FORM_FIELDS } from "../../constants/reportFormFields";

import classes from './PageReport.module.css';

export const PageReport: React.FC = () => {
  return (
    <div className={classes.pageReport}>
        <div className={classes.pageReportTitle}>
          <h2>Отчет</h2>
        </div>
        <Form>
          <div className={classes.pageReportFormItemWrapper} >
            {REPORT_FORM_FIELDS.map((field, index) => (
              <Form.Item 
                name={field.name} 
                label={field.label} 
                key={index} 
                className={classes.pageReportFormItem}
              >
                {field.type === 'select' ? 
                  <Select 
                    size="large" 
                    className={classes.pageReportFormSelect}
                    placeholder={field.placeholder || ''}
                  />
                : 
                  <Input 
                    type={field.type} 
                    size="large" 
                    className={classes.pageReportFormInput}
                    placeholder={field.placeholder || ''}
                  />
                }
              
              </Form.Item>
            ))}
          </div>

          <div className={classes.pageReportActions}>
            <Button className={classes.pageReportCreateReportButton}>
              Сформировать отчет
            </Button>
            <Button className={classes.pageReportCreateCancelButton}>
              Отмена
            </Button>
          </div>
        </Form>
    </div>
   
  );
};
